export type TableMenuType = "row" | "column" | null;

export type TableAction =
    | "addRowAbove"
    | "addRowBelow"
    | "deleteRow"
    | "addColumnBefore"
    | "addColumnAfter"
    | "deleteColumn";

export interface TableControlsState {
    visible: boolean;
    rowTop: number;
    rowLeft: number;
    columnTop: number;
    columnLeft: number;
    menu: TableMenuType;
}

export const emptyTableControls: TableControlsState = {
    visible: false,
    rowTop: 0,
    rowLeft: 0,
    columnTop: 0,
    columnLeft: 0,
    menu: null,
};
